import { Container } from '../..';
import { MoveCard } from './MoveCard';
import { CircadianCard } from './CircadianCard';
import { SleepCard } from './SleepCard';
import { TempratureCard } from './TempratureCard';
import { HRVCard } from './HRVCard';
import { NudgeCard } from './NudgeCard';
import styles from './index.module.css';

export const BentoSection1 = ({
  className,
  bottomPadLess,
}: {
  className?: string;
  bottomPadLess?: boolean;
}) => {
  return (
    <section
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      style={{ paddingBottom: bottomPadLess ? '12px' : undefined }}
    >
      <Container>
        <div className={styles.bentoGrid}>
          <div className={styles.bentoCard}>
            <SleepCard />
          </div>
          <div className={styles.bentoCard}>
            <TempratureCard />
          </div>
          <div className={`${styles.bentoCard} ${styles['span-2']}`}>
            <CircadianCard />
          </div>
          <div className={styles.bentoCard}>
            <MoveCard />
          </div>
          <div className={styles.bentoCard}>
            <HRVCard />
          </div>
          <div className={`${styles.bentoCard} ${styles['span-2']}`}>
            <NudgeCard />
          </div>
        </div>
      </Container>
    </section>
  );
};
